import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=c2b21014&scoped=true"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"
import style0 from "./Blocks.vue?vue&type=style&index=0&id=c2b21014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b21014",
  null
  
)

export default component.exports